import 'yet-another-abortcontroller-polyfill'
import { fetch as whatwgFetch } from 'whatwg-fetch'

export const { AbortController, AbortSignal, fetch: windowFetch } = window
export const fetch = ('signal' in new window.Request(window.location.href)) ? windowFetch : whatwgFetch
export { whatwgFetch }
export default fetch
